var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:{
        'sw-checkbox': true,
        'sw-checkbox_roundings_none': _vm.$simlaweb.settings.roundings === _vm.ROUNDINGS.NONE,
        'sw-checkbox_roundings_small': _vm.$simlaweb.settings.roundings === _vm.ROUNDINGS.SMALL,
        'sw-checkbox_roundings_large': _vm.$simlaweb.settings.roundings === _vm.ROUNDINGS.LARGE,
        'sw-checkbox_disabled': _vm.disabled
    },style:(_vm.styles)},[_c('span',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('input',{attrs:{"type":"checkbox","name":_vm.name},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('change', !_vm.value)}}}),_vm._v(" "),_c('span',{staticClass:"sw-checkbox__checkmark"})])}
var staticRenderFns = []

export { render, staticRenderFns }